module.exports = __webpack_public_path__ + "img/img_upload_3.0707a12a.png";